import { render } from "./google_drive_document_settings.vue?vue&type=template&id=6dea06e0"
import script from "./google_drive_document_settings.vue?vue&type=script&lang=js"
export * from "./google_drive_document_settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__